/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Select_RegionInputs */

const en_select_region = /** @type {(inputs: Select_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select region`)
};

const es_select_region = /** @type {(inputs: Select_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecciona region`)
};

/**
* | output |
* | --- |
* | "Select region" |
*
* @param {Select_RegionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const select_region = /** @type {((inputs?: Select_RegionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Select_RegionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_select_region(inputs)
	return es_select_region(inputs)
});